// home.tsx
import React, { Component } from 'react';
import { Box, Typography, Paper, Button } from '@mui/material';
import "../css/home.css";

import HeroPage from '../assets/hero1.png';
import FeaturesSection from './home/features';

class Home extends Component {
  override render() {
    return (
      <div className='HomePage'>
        <Box
          sx={{
            height: '70vh',
            display: 'grid',
            gridTemplateColumns: {
              xs: '1fr',
              md: '1fr 1fr',
            },
            alignItems: "center",
            justifyContent: "space-between",
            gap: 6,
            px: {
              xs: 3,
              md: 8,
            },
            py: 8,
          }}
        >
          {/* Left Side */}
          <Box
            sx={{
              flex: 1,
              textAlign: {
                xs: "center",
                md: "left",
              },
            }}
          >
            <Typography
              variant="h2"
              className="HeaderMain"
              sx={{
                fontSize: {
                  xs: "2.2rem",
                  sm: "3rem",
                  md: "4rem",
                },
              }}
            >
              Play, Manage and Enjoy!!
            </Typography>

            <Typography
              variant="h5"
              sx={{
                mt: 2,
                fontSize: {
                  xs: "1rem",
                  sm: "1.2rem",
                  md: "1.5rem",
                },
              }}
            >
              RonCafe Launcher provides a unified platform for apps and games across
              multiple categories, making it ideal for both personal and business
              environments.
            </Typography>
            <div className="download-button">
              <Button variant="contained" size="large" sx={{ mt: 4 }} onClick={() => window.location.href = '/download'}>
                Download
              </Button>
              <Button variant="contained" size="large" color='secondary' sx={{ mt: 4 }} onClick={() => window.location.href = '/pricing'}>
                Buy Now
              </Button>
            </div>
          </Box>
          <Box
            component="img"
            src={HeroPage}
            alt="RonCafe Launcher"
            sx={{
              width: {
                xs: "100%",
                sm: "80%",
                md: 1200,
              },
              maxWidth: "100%",
              height: "auto",
              flex: 1,
            }}
          />
        </Box>
        <FeaturesSection />
      </div>
    )
  }
}

export default Home;